// TODO move logic to sports

import type { MarketType } from '@ps/web-sports-api-types';

export const ODDS_BOOST_MARKETS = [
  'POWER_PRICES',
  'ODDS_BOOST',
  'DAILY_POWER_PRICES',
  'POWER_PRICE'
] as const satisfies Readonly<MarketType[]>;

export type OddsBoostMarket = (typeof ODDS_BOOST_MARKETS)[number];

export default (market?: MarketType): market is OddsBoostMarket =>
  ODDS_BOOST_MARKETS.includes(market as OddsBoostMarket);
